import { MessageReplyIcon } from './MessageReplyIcon';

/**
 * author: Google
 * id 6657779A-7238-4686-B3D5-1244862D7B2C
 * name message-reply
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/message-reply.svg
 * tags
 */
export const ModeCommentIcon = MessageReplyIcon;
export default ModeCommentIcon